/** Inline SVG-iconen en illustraties (geen externe assets nodig). */

export function IconClose() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
    </svg>
  );
}

export function IconChevron() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export function IconCheck({ color = 'currentColor' }: { color?: string }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="11" fill={color} />
      <path d="M7 12.5l3.2 3.2L17 9" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export function IconArrows() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M9 7l-5 5 5 5M15 7l5 5-5 5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export function IconAlert() {
  return (
    <svg width="30" height="30" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 7v6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" />
      <circle cx="12" cy="17" r="1.4" fill="currentColor" />
      <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="2" />
    </svg>
  );
}

export function IconLock() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
      <rect x="5" y="10" width="14" height="10" rx="2.5" fill="none" stroke="currentColor" stroke-width="2" />
      <path d="M8 10V7.5a4 4 0 018 0V10" fill="none" stroke="currentColor" stroke-width="2" />
    </svg>
  );
}

export function IconPencil() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 20l4.5-1 10-10a2.1 2.1 0 00-3-3l-10 10L4 20z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
      <path d="M14 7l3 3" stroke="currentColor" stroke-width="2" />
    </svg>
  );
}

export function IconUpload() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 16V6M8 9.5L12 5.5 16 9.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5 19h14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
    </svg>
  );
}

export function IconPhoto() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="5" width="18" height="14" rx="3" fill="none" stroke="currentColor" stroke-width="2" />
      <circle cx="9" cy="10" r="1.8" fill="currentColor" />
      <path d="M4 17l5-5 4 4 3-3 4 4" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
    </svg>
  );
}

/** Van foto naar aquarel: grijze foto links, geschilderde versie rechts. */
export function HeroArt({ label = 'Een foto wordt een aquarel' }: { label?: string }) {
  return (
    <svg viewBox="0 0 320 150" role="img" aria-label={label}>
      <defs>
        <linearGradient id="aps-hero-photo" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stop-color="#dcd7d3" />
          <stop offset="1" stop-color="#aaa39e" />
        </linearGradient>
        <filter id="aps-hero-wc" x="-10%" y="-10%" width="120%" height="120%">
          <feTurbulence type="fractalNoise" baseFrequency="0.04" numOctaves="2" seed="4" result="noise" />
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="7" />
          <feGaussianBlur stdDeviation="0.7" />
        </filter>
        <filter id="aps-hero-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="4" stdDeviation="5" flood-color="#8a5a44" flood-opacity="0.18" />
        </filter>
      </defs>
      <g transform="rotate(-4 72 76)" filter="url(#aps-hero-shadow)">
        <rect x="16" y="18" width="112" height="116" rx="6" fill="#fff" />
        <rect x="24" y="26" width="96" height="84" rx="3" fill="url(#aps-hero-photo)" />
        <circle cx="60" cy="58" r="13" fill="#7d7672" />
        <circle cx="86" cy="63" r="11" fill="#8d8682" />
        <path d="M36 110q24-34 48 0z" fill="#6f6864" />
        <path d="M66 110q21-29 42 0z" fill="#817a76" />
      </g>
      <path d="M142 80q19-15 38 0" stroke="#d67e60" stroke-width="3" fill="none" stroke-linecap="round" />
      <path d="M173 71l8 9-11 3" stroke="#d67e60" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M158 50l2 5 5 2-5 2-2 5-2-5-5-2 5-2z" fill="#f0b39d" />
      <path d="M176 44l1.3 3.2 3.2 1.3-3.2 1.3-1.3 3.2-1.3-3.2-3.2-1.3 3.2-1.3z" fill="#a9cbe0" />
      <g transform="rotate(4 248 76)" filter="url(#aps-hero-shadow)">
        <rect x="192" y="18" width="112" height="116" rx="6" fill="#fff" />
        <g filter="url(#aps-hero-wc)">
          <rect x="200" y="26" width="96" height="84" rx="3" fill="#fbf4ee" />
          <circle cx="226" cy="44" r="19" fill="#f6d8c7" opacity="0.8" />
          <circle cx="274" cy="50" r="21" fill="#d3e5f0" opacity="0.8" />
          <circle cx="236" cy="58" r="13" fill="#eab8a1" />
          <circle cx="262" cy="63" r="11" fill="#f1caae" />
          <path d="M212 110q24-34 48 0z" fill="#9fc3d9" />
          <path d="M242 110q21-29 42 0z" fill="#e8a893" />
        </g>
        <g fill="none" stroke="#6e5d55" stroke-width="0.9" opacity="0.55">
          <circle cx="236" cy="58" r="13" />
          <circle cx="262" cy="63" r="11" />
          <path d="M212 110q24-34 48 0M242 110q21-29 42 0" />
        </g>
      </g>
    </svg>
  );
}
